import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  MenuItem,
  Snackbar,
  Stack,
  TextField,
  Typography,
  Alert as MuiAlert
} from '@mui/material'
import { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { businessCheck } from '../../utils/utils'
import {
  ErrorScreen,
  ShowNoRecordsFound,
  SnackBarHideDuration,
  SnackBarTransition
} from '../../utils/ui_utils'
import { useFetchOutlet } from '../../modules/outlet/outletHooks'
import ListTypeShimmer from '../../utils/ui_components/shimmers/listTypeShimmer'
import _ from 'lodash'
import {
  usePaymentMethodFetch,
  usePaymentMethodCreate,
  usePaymentMethodUpdate,
  usePaymentMethodbulkSave,
  usePaymentMethodCreateDefault
} from '../../modules/paymentMethod/paymentMethodHooks'
import PaymentMethodComponent from './payment_method_component/paymentMethodComponent'
import CreatePaymentMethod from './payment_method_component/CreatePaymentMethod'
import { Add as AddIcon } from '@mui/icons-material'

function PaymentMethod() {
  const [selectedOutlet, setSelectedOutlet] = useState('')
  const [outlets, setOutlets] = useState([])
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } =
    useFetchOutlet()
  const {
    fetchPaymentMethod,
    paymentMethodFetchData,
    paymentMethodFetchError,
    paymentMethodFetchLoading
  } = usePaymentMethodFetch()
  const { createPaymentMethod } = usePaymentMethodCreate()
  const {
    bulkSavePaymentMethod,
    paymentMethodSaveLoading,
    paymentMethodSaveError,
    paymentMethodSaveData
  } = usePaymentMethodbulkSave()
  const { createDefaultPaymentMethod } = usePaymentMethodCreateDefault()
  const [openCreateDailog, setOpenCreateDailog] = useState(false)
  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const history = useNavigate()

  const fetchRecords = () => {
    let payload = {
      pageNumber: 1,
      limit: 100
    }
    outletFetch(payload)
  }

  useEffect(() => {
    businessCheck(history)
    fetchRecords()
  }, [])

  useEffect(() => {
    if (outletFetchData.data?.length > 0) {
      setOutlets(outletFetchData.data)
      setSelectedOutlet(outletFetchData.data[0]?._id)
      let paymentPayload = {
        outlet_id: outletFetchData.data[0]?._id,
        pageNumber: 1,
        limit: 100
      }
      fetchPaymentMethod(paymentPayload)
    } else {
      setOutlets([])
      setSelectedOutlet('')
    }
  }, [outletFetchData])

  const handleOutletChange = (event) => {
    setSelectedOutlet(event.target.value)
    fetchPaymentMethods(event.target.value)
  }

  const fetchOutletOnError = () => {
    fetchRecords()
  }

  const fetchPaymentMethods = (outlet_id) => {
    let paymentPayload = {
      outlet_id: outlet_id,
      pageNumber: 1,
      limit: 100
    }
    fetchPaymentMethod(paymentPayload)
  }

  return (
    <>
      <Helmet title="Payment Methods" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item>
          <Typography variant="h4" gutterBottom display="inline">
            Payment Methods
          </Typography>
        </Grid>
      </Grid>
      <Divider style={{ paddingTop: 10 }} />
      {outletFetchError ? (
        <ErrorScreen
          onClick={() => {
            fetchOutletOnError()
          }}
        />
      ) : (
        <div>
          <Grid
            container
            justifyContent={'space-between'}
            spacing={6}
            style={{ paddingTop: 10 }}
          >
            <Grid item md={3}>
              <TextField
                size="small"
                label="Outlet"
                id="outlet_id"
                name="outlet_id"
                variant="outlined"
                margin="dense"
                value={selectedOutlet}
                onChange={handleOutletChange}
                select
                fullWidth
              >
                {outlets.map((outlet) => (
                  <MenuItem key={outlet._id} value={outlet._id}>
                    {outlet.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            {paymentMethodFetchData.data?.length > 0 && (
              <Grid item>
                <Button
                  startIcon={<AddIcon />}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setOpenCreateDailog(true)
                  }}
                >
                  Payment Method
                </Button>
              </Grid>
            )}
          </Grid>
          {paymentMethodFetchError ? (
            <ErrorScreen
              onClick={() => {
                fetchPaymentMethods(selectedOutlet)
              }}
            />
          ) : (
            <div>
              {outletFetchLoading ||
                (paymentMethodFetchLoading && <ListTypeShimmer />)}
              {!outletFetchLoading &&
                !paymentMethodFetchLoading &&
                outlets &&
                outlets?.length <= 0 && <ShowNoRecordsFound />}
              {!paymentMethodFetchError &&
                !outletFetchError &&
                !paymentMethodFetchLoading &&
                !outletFetchLoading &&
                outlets &&
                outlets.length > 0 && (
                  <Grid container>
                    <Grid item md={12}>
                      <Box style={{ paddingTop: 20 }}>
                        {selectedOutlet == '' ? (
                          <></>
                        ) : paymentMethodFetchData.data?.length === 0 ? (
                          <Card
                            raised
                            style={{ width: '80%', borderRadius: 10 }}
                          >
                            <CardContent>
                              {' '}
                              <Stack
                                direction="column"
                                spacing={3}
                                sx={{ margin: 10, alignItems: 'center' }}
                              >
                                <Typography variant="h5" component="span">
                                  {' '}
                                  PaymentMethod are not avalable for this
                                  Outlet.{' '}
                                </Typography>
                                <Button
                                  onClick={() => {
                                    createDefaultPaymentMethod(
                                      selectedOutlet,
                                      (success, error, res) => {
                                        if (error) {
                                          toastMessage(res, 'error')
                                        } else {
                                          fetchPaymentMethods(selectedOutlet)
                                          toastMessage(res, 'success')
                                        }
                                      }
                                    )
                                  }}
                                >
                                  Create default PaymentMethod
                                </Button>
                              </Stack>
                            </CardContent>
                          </Card>
                        ) : (
                          <PaymentMethodComponent
                            initialValues={paymentMethodFetchData}
                            okText={'Update'}
                            onError={(res, severity) => {
                              toastMessage(res, severity)
                            }}
                            onDeleteSuccess={(message) => {
                              toastMessage(message, 'success')
                              fetchPaymentMethods(selectedOutlet)
                            }}
                            onSubmit={(values) => {
                              let _values = _.cloneDeep(values)
                              let updatedValues = _values?.map((item) => {
                                let { business_id, timestamp, ...rest } = item
                                return rest
                              })
                              let body = {
                                payment_method: updatedValues,
                                outlet_id: selectedOutlet
                              }
                              bulkSavePaymentMethod(
                                body,
                                (success, error, res) => {
                                  if (error) {
                                    toastMessage(res, 'error')
                                  } else {
                                    fetchPaymentMethods(selectedOutlet)
                                    toastMessage(res, 'success')
                                  }
                                }
                              )
                            }}
                          />
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                )}
            </div>
          )}
        </div>
      )}

      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
      <CreatePaymentMethod
        open={openCreateDailog}
        closeWindow={() => setOpenCreateDailog(false)}
        onSubmit={(values) => {
          let body = {
            payment_method: values.payment_method.trim(),
            outlet_id: selectedOutlet,
            payment_method_flag: true
          }
          createPaymentMethod(body, (success, error, message) => {
            if (error) {
              toastMessage(message, 'error')
            } else {
              setOpenCreateDailog(false)
              toastMessage('Payment Method created', 'success')
              fetchPaymentMethods(selectedOutlet)
            }
          })
        }}
      />
    </>
  )
}
export default PaymentMethod
